import { HttpClient } from '@angular/common/http'
import { UtilityService } from './utility.service'
import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import { retry } from 'rxjs/operators'

import { INTEGRATION_WORD_CONSTANTS } from '../shared/constants/integration-word-constant'

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private utility: UtilityService, private http: HttpClient) {}
  /**
   * Logins  function
   * @param payload  Object
   * @returns  Observable
   */
  login(payload: any) {
    const loginPayload = this.generatePayload(payload)
    return this.http.post(environment.authEndpoint + '?mode=login', loginPayload)
  }

  loginWord(payload: any) {
    const loginPayload = this.generatePayload(payload)
    return this.http.post(environment.authEndpoint + INTEGRATION_WORD_CONSTANTS.LOGIN + INTEGRATION_WORD_CONSTANTS.MS_WORD, loginPayload)
  }

  /**
   * Verifys mfa pin
   * @param payload object
   * @returns  Obsevable
   */
  verifyMFA(payload: any) {
    const loginPayload = this.generatePayload(payload)
    return this.http.post(environment.authEndpoint + '?mode=MFAlogin', loginPayload)
  }
  /**
   * Verifys recovery code
   * @param payload object
   * @returns  Observable
   */
  verifyRecoveryCode(payload: any) {
    const loginPayload = this.generatePayload(payload)
    return this.http.post(environment.authEndpoint + '?mode=MFArecoverylogin', loginPayload).pipe(retry(1))
  }
  /**
   * Generates payload by merging user details
   * @param payload object
   * @returns  object
   */
  generatePayload(payload: any, userDetails = this.utility.getUserDetails()) {
    return { ...userDetails, ...payload }
  }
}
